import React from "react";
import { bool, elementType, node, oneOfType, string } from "prop-types";
import { classes } from "../utils/classes";

const HeaderTag = ({
	Tag = "header",
	isHero = false,
	isBorderBottomNone,
	className = "",
	children,
}) => (
	<Tag
		className={classes(
			"header",
			isHero && "header--hero",
			isBorderBottomNone && "header--border-none",
			className,
		)}
		role="banner"
	>
		{children}
	</Tag>
);

HeaderTag.propTypes = {
	Tag: oneOfType([string, elementType]),
	isHero: bool,
	isBorderBottomNone: bool,
	children: node.isRequired,
	className: string,
};

export default HeaderTag;
